import { CommonCenterModal } from 'shared/ui/Modal/CommonCenterModal';

export const Noti = ({ setIsValidData }) => {
  return (
    <CommonCenterModal
      title='환자 정보 등록 안내'
      subTitle={
        <>
          환자 연락처 또는 주소 정보가 등록되어 있지 않아, 모바일로 입원 약정서 및 동의서를 작성할 수 없어요. 입원 수속
          창구에서 환자 정보를 등록 후 모바일 또는 창구에서 동의서를 작성할 수 있어요.
        </>
      }
      btnText='확인'
      show={true}
      handleClose={() => {
        setIsValidData(true);
      }}
    />
  );
};
